"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
var RANGE = 10000000;
function Registrable(ctor) {
    var randomValues = crypto.getRandomValues(new Uint32Array(1));
    var sid = Math.floor(randomValues[0] % RANGE).toString();
    Reflect.defineMetadata("sparksonRegistrable", sid, ctor);
    return undefined;
}
exports.Registrable = Registrable;
